import { Context, createContext, FC, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react';
import { IAlert } from '../common/io/alert.response';
import { getFromSessionStorage, setToSessionStorage } from '../utils/storage.util';

interface AlertsContextProps {
	alerts: IAlert;
	setAlerts: Function;
}

const emptyAlerts: IAlert = { messages: 0, notifications: 0, tests: 0, videos: 0 };

const AlertsContext: Context<AlertsContextProps> = createContext<AlertsContextProps>({
	alerts: {},
	setAlerts: (alerts: IAlert): void => setToSessionStorage('alerts', JSON.stringify(alerts)),
});

const AlertsProvider: FC<{ children: ReactNode }> = ({ children }): ReactElement => {
	const [alerts, setAlerts] = useState<IAlert>((): any => {
		const savedAlerts: any = getFromSessionStorage('alerts');
		return savedAlerts ? JSON.parse(savedAlerts) : emptyAlerts;
	});

	useEffect((): void => {
		setToSessionStorage('alerts', JSON.stringify(alerts ?? emptyAlerts));
	}, [alerts]);

	const value: AlertsContextProps = useMemo((): AlertsContextProps => ({ alerts, setAlerts }), [alerts]);

	return (
		<AlertsContext.Provider value={value}>
			{children}
		</AlertsContext.Provider>
	);
}

export { AlertsContext, AlertsProvider };
export type { AlertsContextProps };
